

export function ToolsItem(props){

    const [title, text, image, number, marker] = props.data;

    return(
        <div className='tools-inner-container__content-container'>
            <div className='tools-inner-container__content-container__header-container'>
                <h4 className='tools-inner-container__content-container__text-container__header'
                    dangerouslySetInnerHTML={{__html: title}}></h4>
            </div>
            <div className='tools-inner-container__content-container__text-container'>
                
                <p className='tools-inner-container__content-container__text-container__text'
                    dangerouslySetInnerHTML={{__html: text}}></p>
            </div>
        </div>
    )

}